import { useMutation, useQueryClient, UseMutationOptions } from '@tanstack/react-query'
import UserManagementApi from '../../../api/resources/UserManagementApi'
import { InviteUserBody } from '@valuecase/seller-backend'

export async function updateUserRoleFn(user: InviteUserBody): Promise<void> {
  await UserManagementApi.inviteUser(user)
}

export function useInviteUser<TError = unknown>({
  onSuccess,
  ...options
}: Omit<UseMutationOptions<void, TError, InviteUserBody>, 'mutationFn'> = {}) {
  const queryClient = useQueryClient()
  return useMutation<void, TError, InviteUserBody>({
    mutationFn: updateUserRoleFn,
    onSuccess: (...args) => {
      onSuccess?.(...args)
      setTimeout(() => {
        try {
          queryClient.invalidateQueries({ queryKey: ['readUsers'] })
        } catch (err) {
          console.error('Error invalidating queries:', err)
        }
      }, 2000)
    },
    ...options,
  })
}
